<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      {{ $t("auditoria-pendencias") }} (Total: {{ sum }})
      <el-form style="float: right; padding: 3px 0" :inline="true">
        <AuditPendenciesUp ref="up" v-on:filter="fetchRecords" />&nbsp;
        <AuditPendenciesFilter ref="filter" v-on:filter="fetchRecords" />&nbsp;
        <AuditPendenciesExport v-on:export="exportData" />
      </el-form>
    </div>
    <AuditPendenciesDetail :list="tableDashboard" v-on:reload="reload" :type="type" v-on:option="option" />
    <br />
    <AuditPendenciesCustomerByCardPost :type="type" ref="cardpost" v-on:reload="fetchRecords" />
    <AuditPendenciesValueMore :type="type" ref="value" v-on:reload="fetchRecords" />
    <AuditPendenciesServices :type="type" ref="services" v-on:reload="fetchRecords" />
    <AuditPendenciesCardPostDiff ref="diff" v-on:reload="fetchRecords" />
    <AuditPendenciesTable :tableData="tableData" :tag="tag" :type="type" :total="total" v-on:reload="changepage" />
  </el-card>
</template>
<script>
import { AuditService } from "@/services/customers/audit.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import AuditPendenciesCardPostDiff from './audit/AuditPendenciesCardPostDiff';
import AuditPendenciesCustomerByCardPost from './audit/AuditPendenciesCustomerByCardPost';
import AuditPendenciesDetail from './audit/AuditPendenciesDetail';
import AuditPendenciesExport from './audit/AuditPendenciesExport';
import AuditPendenciesFilter from './audit/AuditPendenciesFilter';
import AuditPendenciesServices from './audit/AuditPendenciesServices';
import AuditPendenciesTable from './audit/AuditPendenciesTable';
import AuditPendenciesValueMore from './audit/AuditPendenciesValueMore';
import moment from "moment";
import AuditPendenciesUp from "./audit/AuditPendenciesUp.vue";

export default {
  name: "AuditList",
  components: {
    CustomerList,
    AuditPendenciesFilter,
    AuditPendenciesTable,
    AuditPendenciesCardPostDiff,
    AuditPendenciesDetail,
    AuditPendenciesExport,
    AuditPendenciesValueMore,
    AuditPendenciesCustomerByCardPost,
    AuditPendenciesServices,
    AuditPendenciesUp
},
  data() {
    return {
      tableData: [],
      tableDashboard: [],
      tag: null,
      page: 1,
      userType: '2',
      type: '',
      total: 0,
      action: '',
    };
  },
  computed: {
    sum() {
      return this.tableDashboard.reduce((a, b) => {
        return a + +b.total
      }, 0)
    },
  },
  methods: {
    reload(type) {
      this.type = type;
      this.page = 1;
      this.$refs.filter.clear();
      this.fetchRecords();
    },
    changepage(page) {
      if (page) this.page = page;

      this.fetchRecords();
    },
    option(type, action) {
      this.type = type;
      if (type === '2' && action === 'object') {
        this.fetchRecords();
      } else if (type === '3') {
        this.$refs.diff.show(action)
      } else {
        this.$refs[action].show(action)
      }
    },
    exportData(fileType) {
      const vm = this;
      const filter = vm.$refs.filter.get();
      const loading = vm.$loading(vm.$options.loading);
      AuditService.export(filter, fileType)
        .then((response) => {
          this.$message({
            type: "warning",
            message: 'Seu relatório de auditoria está sendo gerado, assim que terminar você receberá uma notificação no canto superior direito!',
            duration: 5000,
          });
          vm.$bus.$emit("notifications", response.id);
        })
        .catch((error) => {
          vm.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
    },
    fetchRecords() {
      const vm = this;
      vm.tableData = [];
      const filter = vm.$refs.filter.get();

      const initialDate = filter.range[0] ? moment(filter.range[0]).format("YYYY-MM-DD") : undefined;
      const endDate = filter.range[1] ? moment(filter.range[1]).format("YYYY-MM-DD") : undefined;

      this.$refs.cardpost.hide()
      filter.type = vm.type;
      vm.tag = null;
      const loading = vm.$loading(vm.$options.loading);
      AuditService.pendencies(vm.page, {
        cardpost: filter.cardpost,
        customer: filter.customer,
        service: filter.service,
        tag: filter.tag,
        type: filter.type,
        initialDate,
        endDate,
        orderByDate: filter.orderByDate
      })
        .then((response) => {
          vm.tableDashboard = response.dashboard;
          if (filter.tag) {
            if (response.tag.error) {
              return vm.$message({ type: "error", message: response.tag.message });
            }
            vm.tag = response.tag.data;
          }
          vm.tableData = response.pendencies.data;
          vm.total = response.pendencies.total;
        })
        .catch((error) => {
          vm.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
        vm.fetchRecords();
      })
      .catch((error) => {
        this.$message({ type: "error", message: error });
      });
  },
};
</script>
